import ApiModelWithAuth from "../../../models/ApiModelWithAuth";
import Formatter from "../../../models/Formatter";

export class FileFormatter extends Formatter {
}

// Файлы панели (authorized/admin/files) — сейчас это библиотека APK. Три отличия от
// обычного CRUD, из-за них переопределены Update и getParamsForStore:
//   • тело записи — multipart (поля name/file), а не JSON;
//   • обновление висит на POST files/{id}, а не на PATCH — PHP разбирает multipart
//     только для POST (см. докблок FilesController в API);
//   • удаления в API нет вовсе — карточка отдаётся с withDestroy={false}.
export default class ApiFile extends ApiModelWithAuth {
    pathDef = 'authorized/admin/files';
    formatterItem = FileFormatter.Item;
    isSendFile = true; // тело — FormData: Content-Type с boundary ставит браузер

    // Обновление — тот же POST, что и создание, но по пути files/{id}: тип 'store' с
    // подменой пути (приём из ApiDevice.__PostAction). Базовый 'update' не подходит — PATCH.
    static Update(id, params = {}) {
        const api = super.Store(params);
        api.paths = { 'store': `${api.pathDef}/${id}` };
        return api;
    }

    // name и/или file → FormData. Пустые поля НЕ кладём: update принимает их по
    // отдельности — переименование без перезаливки и наоборот (FileApkRequest).
    getParamsForStore(params) {
        const formData = new FormData();
        if (params.name) formData.append('name', params.name);
        if (params.file instanceof File) formData.append('file', params.file);
        return formData;
    }
}
